import { useEffect, useState, useMemo } from 'react';
import { Col, Form, InputGroup, Row } from 'react-bootstrap';
import { Formik, useFormikContext, Field } from 'formik';
import { isValid, parse } from 'date-fns';
import { Select, Input, DatePickerEvent, CustomDatePicker } from 'components';
import { useWindowSize } from 'hooks';
import { initialValues, schema, monthsOptions, yearsOptions } from './config';
import './index.scss';

const SpecialDate = ({ onSaveData }) => {
  const formik = useFormikContext();
  const [selectedDate, setSelectedDate] = useState({
    day: '',
    month: '',
    year: ''
  });
  const [later] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [hasInvalidDate, setHasInvalidDate] = useState(false);
  const [minDate, setMinDate] = useState(new Date());
  const [, { isMobile }] = useWindowSize();

  const minimumDays = useMemo(
    () => formik.values.minimumDays,
    [formik.values.minimumDays]
  );

  const daysFromToday = (date) => {
    const aDay = 1000 * 60 * 60 * 24;
    return (parse(date, 'yyyy-M-d', new Date()) - new Date()) / aDay;
  };

  const isDateValid = (newDate, minimumDays) => {
    const isGreatenThatRestriction = daysFromToday(newDate) > minimumDays;
    const withValidFormat = isValid(parse(newDate, 'yyyy-M-d', new Date()));

    if (!isGreatenThatRestriction && Number(minimumDays))
      setErrorMessage(
        `La mesa debe crearse al menos ${minimumDays} días antes de tu evento`
      );
    else if (!withValidFormat) setErrorMessage('Selecciona una fecha válida');

    return isGreatenThatRestriction && withValidFormat;
  };

  const padZeroes = (val) => `0${val}`.slice(-2);

  const separarFecha = (fecha) => {
    const [year, month, day] = fecha.split('-');
    return {
      year: parseInt(year, 10),
      month: parseInt(month, 10),
      day: parseInt(day, 10)
    };
  }

  const saveDate = (value) => {
    formik.setFieldValue('eventDate', value);
    const newDate = separarFecha(value)

    setSelectedDate(newDate);
    const newVal = `${newDate.year}-${newDate.month}-${newDate.day}`;
    const event_date = `${newDate.year}${padZeroes(newDate.month)}${padZeroes(
      newDate.day
    )}`;
    onSaveData({
      ...newDate,
      event_date,
      date: newVal,
      valid: isDateValid(newVal, minimumDays)
    }, 'special_date');
  };

  useEffect(() => {
    setHasInvalidDate(
      formik.values?.date && !isDateValid(formik.values?.date, minimumDays)
    );
  }, [formik.values?.date, minimumDays]);

  const handleDateChange = (event) => {
    formik.handleChange(event);
    saveDate(event)
  };

  useEffect(() => {
    const dtToday = new Date();
    dtToday.setDate(dtToday.getDate()); // Suma 10 días a la fecha actual
    let month = dtToday.getMonth() + 1;
    let day = dtToday.getDate();
    const year = dtToday.getFullYear();
    if(month < 10) month = `0${month}`;
    if(day < 10) day = `0${day}`;    
    const maxDate = `${year}-${month}-${day}`;
    setMinDate(maxDate);
  },[]);

  return (
    <section className="SpecialDate">
      <Form>
        {!isMobile ? (
        <div className='row justify-content-center'>
          <label htmlFor="eventDate" className='col-md-7 offset-1 form-label'>Fecha:</label>
          <InputGroup hasValidation className="col-md-7 offset-1">
            <input
              type="date"
              name="eventDate"
              label="Fecha:"
              value={formik.values?.eventDate}
              onChange={(e) => handleDateChange(e.target.value)}
              className="form-control inputborder"
              placeholder="dd/mm/aaaa"
              // placeholdertext="dd/mm/aaaa"
              min={minDate}       
            />
            {/*
            <div className="input-group-prepend d-block d-md-none">
              <span className="input-group-text bg-white" style={{ display: 'flex', alignItems: 'center', border: 'none' }}>
                <i className="fa fa-calendar-o" aria-hidden="true" style={{ backgroundColor: 'white', zIndex: '1', marginLeft: '-48px',marginTop:'11px' }} />
                </span>
            </div>
            */}
            {hasInvalidDate && (
              <Form.Control.Feedback className="col-md-6 offset-md-3" type="invalid">
                {errorMessage}
              </Form.Control.Feedback>
            )}
          </InputGroup>
        </div>
        ) : (
        <div className='row justify-content-center'>
          <label htmlFor="eventDate" className='col-md-7 offset-1 form-label'>Fecha:</label>
          <Field 
            name="eventDate"
            component={CustomDatePicker}
            label=''
            maxLength={50}
            value={formik.values?.eventDate}
            onChange={(e) => handleDateChange(e.target.value)}
            min={minDate}
            inputClassName='col-md-7'
            />
        </div>
        )}
                
      </Form>
    </section>
  );
};

export default SpecialDate;
